import {
  AlertCircle,
  Bell,
  CheckCircle,
  Info,
  Briefcase,
  Users,
} from 'lucide-react';
import type { NotificationType, NotificationPriority } from '@/types/notification';
import { cn } from '@/lib/utils';

interface NotificationIconProps {
  type: NotificationType;
  priority: NotificationPriority;
  className?: string;
}

export function NotificationIcon({ type, priority, className }: NotificationIconProps) {
  const iconClasses = cn(
    'h-4 w-4',
    priority === 'high' && 'text-destructive',
    priority === 'medium' && 'text-yellow-500',
    priority === 'low' && 'text-muted-foreground',
    className
  );

  switch (type) {
    case 'system_alert':
      return <AlertCircle className={iconClasses} />;
    case 'action_required':
      return <Bell className={iconClasses} />;
    case 'application_status':
      return <CheckCircle className={iconClasses} />;
    case 'project_match':
      return <Briefcase className={iconClasses} />;
    case 'committee_assignment':
      return <Users className={iconClasses} />;
    case 'info':
    default:
      return <Info className={iconClasses} />;
  }
}
